import { getHttpEndpoint } from "@orbs-network/ton-access";
import { useQuery } from "@tanstack/react-query";
import { TonClient } from "@ton/ton";
import axios, { getAdapter } from "axios";
import { useNetwork } from "./useNetwork";
const MAINNET_NODE_1 = "https://toncenter.com/api/v2/jsonRPC";
const TESTNET_NODE_1 = "https://dev.architecton.site/api/v2/node/rpc/jsonRPC";
const TESTNET_NODE_2 = "https://testnet.toncenter.com/api/v2/jsonRPC";
const rateLimitRetryAdapter = async (config) => {
    const maxRetries = 3;
    const retryDelay = 1000;
    let retries = 0;
    const defaultAdapter = getAdapter(axios.defaults.adapter);
    if (config.data && typeof config.data === "object") {
        config.data = JSON.stringify(config.data);
    }
    config.headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...config.headers,
    };
    if (!defaultAdapter) {
        throw new Error("Axios default adapter is not available");
    }
    while (retries <= maxRetries) {
        try {
            const response = await defaultAdapter(config);
            if (response.data && typeof response.data === "string") {
                try {
                    response.data = JSON.parse(response.data);
                }
                catch (_e) {
                    console.warn("Failed to parse response data as JSON");
                }
            }
            return response;
        }
        catch (err) {
            const error = err;
            const status = error.response?.status;
            // If rate limit hit (429), wait and retry
            if (status === 429 && retries < maxRetries) {
                retries += 1;
                console.debug(`🔄 @arc/sdk: Rate limit exceeded [Attempt ${retries}/${maxRetries}] - Retrying in ${retryDelay / 1000}s...`);
                await new Promise((resolve) => setTimeout(resolve, retryDelay));
            }
            else {
                throw error;
            }
        }
    }
    // Should never reach this point
    throw new Error(`Rate limit exceeded after ${maxRetries} retries.`);
};
export const useTonClient = (options = {}) => {
    const { network: sdkNetwork } = useNetwork();
    return useQuery({
        queryKey: ["tonClient", options.network || sdkNetwork],
        queryFn: async () => {
            const network = options.network || sdkNetwork;
            let orbsEndpoint = "";
            try {
                orbsEndpoint = await getHttpEndpoint({
                    network: options.network || sdkNetwork,
                });
            }
            catch (e) {
                console.log("====================");
                console.log({ e });
                console.log("====================");
            }
            const endpoints = network === "testnet" ? [TESTNET_NODE_1, TESTNET_NODE_2] : [MAINNET_NODE_1, orbsEndpoint];
            for (const endpoint of endpoints) {
                try {
                    if (!endpoint) {
                        throw new Error("Endpoint is not defined");
                    }
                    const client = new TonClient({ endpoint, httpAdapter: rateLimitRetryAdapter });
                    // Проверяем подключение
                    await client.getMasterchainInfo();
                    return client;
                }
                catch (error) {
                    console.log({ error });
                    console.warn(`Failed to connect to ${endpoint}. Trying next endpoint.`);
                }
            }
            throw new Error("Failed to connect to any TON node.");
        },
        retry: false,
        staleTime: Infinity,
    });
};
//# sourceMappingURL=useTonClient.js.map